<template>
    <div>

        <b-row>

            <b-col lg="3" md="6">
                <h6 class="text-center">{{totalAgreements}} Convenios</h6>
                <pie-chart :chart-data="agreementsChartData" :options="options"/>
            </b-col>

            <b-col lg="3" md="6">
                <h6 class="text-center">{{totalQueries}} Consultas</h6>
                <pie-chart :chart-data="queriesChartData" :options="options"/>
            </b-col>

            <b-col lg="3" md="6">
                <h6 class="text-center">Respuestas</h6>
                <pie-chart :chart-data="queriesResponseChartData" :options="options"/>
            </b-col>

            <b-col lg="3" md="6">
                <h6 class="text-center">{{totalReceipts}} Recibos</h6>
                <pie-chart :chart-data="receiptsChartData" :options="options"/>
            </b-col>

        </b-row>

    </div>
</template>

<script>

    import {getMemberStatisticsResume} from '@/api/statistics-api';
    import PieChart from '@/components/charts/PieChart';

    export default {
        name: "MemberStatisticsResume",
        props: [
            'memberId',
            'showLegend'
        ],
        components: {
            PieChart
        },
        data: function() {
            return {
                totalAgreements: null,
                agreementsChartData: {},
                totalQueries: null,
                queriesChartData: {},
                queriesResponseChartData: {},
                totalReceipts: null,
                receiptsChartData: {},
                options: {
                    responsive: true,
                    legend: {
                        display: this.showLegend
                    }
                }
            }
        },
        mounted() {
            this.options.legend.display = this.showLegend;
            this.getStatistics();
        },
        watch: {
            memberId() {
                this.getStatistics();
            }
        },
        methods: {
            getStatistics() {
                getMemberStatisticsResume(this.memberId).then((data) => {
                    this.totalAgreements = data.agreements.applied;

                    this.agreementsChartData = {
                        labels: ["Activos", "De Cuota", "Otros"],
                        datasets: [
                            {
                                backgroundColor: ['#BCE784', '#DEF4C6', '#F8FA90', '#DAFF7D'],
                                data: [
                                    data.agreements.active,
                                    data.agreements.fee,
                                    data.agreements.others
                                ]
                            },
                        ]
                    };

                    this.totalQueries = data.queries.total;

                    this.queriesChartData = {
                        labels: ["Abiertas", "Resueltas", "Cerradas"],
                        datasets: [
                            {
                                backgroundColor: ['#BCE784', '#DEF4C6', '#F8FA90', '#DAFF7D'],
                                data: [data.queries.open, data.queries.resolved, data.queries.closed]
                            },
                        ]
                    };

                    this.queriesResponseChartData = {
                        labels: ["En plazo", "Fuera de plazo"],
                        datasets: [
                            {
                                backgroundColor: ['#BCE784', '#DEF4C6', '#F8FA90', '#DAFF7D'],
                                data: [data.queries.in_time, data.queries.out_of_time,]
                            },
                        ]
                    };

                    this.totalReceipts = data.receipts.num_receipts;

                    let pending = this.totalReceipts - data.receipts.num_receipts_treated - data.receipts.num_receipts_charged - data.receipts.num_receipts_canceled;
                    this.receiptsChartData = {
                        labels: ["Pendientes", "Tratados", "Cargados", "Cancelados"],
                        datasets: [
                            {
                                backgroundColor: ['#BCE784', '#DEF4C6', '#F8FA90', '#DAFF7D'],
                                data: [
                                    pending,
                                    data.receipts.num_receipts_treated,
                                    data.receipts.num_receipts_charged,
                                    data.receipts.num_receipts_canceled
                                ]
                            },
                        ]
                    };
                });
            }
        },
    }
</script>

<style scoped>

</style>